import { render, staticRenderFns } from "./RecommendedProductSlider.vue?vue&type=template&id=2c06b75a&scoped=true"
import script from "./RecommendedProductSlider.vue?vue&type=script&lang=js"
export * from "./RecommendedProductSlider.vue?vue&type=script&lang=js"
import style0 from "./RecommendedProductSlider.vue?vue&type=style&index=0&id=2c06b75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06b75a",
  null
  
)

export default component.exports